import { render, staticRenderFns } from "./ModalCadastroCompetencia.vue?vue&type=template&id=1c3e4440"
import script from "./ModalCadastroCompetencia.vue?vue&type=script&lang=js"
export * from "./ModalCadastroCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports